/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sklik_Refresh_StatsInputs */

const cs_sklik_refresh_stats = /** @type {(inputs: Sklik_Refresh_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obnovit statistiky (30 dní)`)
};

const en_sklik_refresh_stats = /** @type {(inputs: Sklik_Refresh_StatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Refresh stats (30d)`)
};

/**
* | output |
* | --- |
* | "Refresh stats (30d)" |
*
* @param {Sklik_Refresh_StatsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sklik_refresh_stats = /** @type {((inputs?: Sklik_Refresh_StatsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sklik_Refresh_StatsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sklik_refresh_stats(inputs)
	return cs_sklik_refresh_stats(inputs)
});